(() => {
  const mobileQuery = window.matchMedia('(max-width: 900px)');

  const splitProduct = (scope = document) => {
    const product = scope.querySelector?.('[data-vrx-product]') || document.querySelector('[data-vrx-product]');
    if (!product || product.dataset.vrxProductSplit === 'true') return;

    const grid = product.querySelector('.vrx-product__grid');
    const copy = grid?.querySelector('.vrx-product__copy');
    const proof = product.querySelector('.vrx-product__proof');
    const points = product.querySelector('.vrx-product__points');
    if (!grid || !proof || !points) return;

    const after = document.createElement('div');
    after.className = 'vrx-product__after';
    after.dataset.vrxProductAfter = 'true';
    after.append(proof, points);
    grid.insertAdjacentElement('afterend', after);

    copy?.classList.add('vrx-product__copy--primary');
    product.classList.add('vrx-product--split');
    product.dataset.vrxProductSplit = 'true';
  };

  const optimizeVideos = (scope = document) => {
    if (!mobileQuery.matches || !('IntersectionObserver' in window)) return;

    const videos = scope.querySelectorAll?.('.vrx video:not([data-vrx-mobile-optimized])') || [];
    videos.forEach((video) => {
      if (video.closest('.vrx-hero__media')) return;

      video.dataset.vrxMobileOptimized = 'true';
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.loop = true;
      video.autoplay = false;
      video.removeAttribute('autoplay');
      video.preload = 'none';

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (video.readyState === 0) video.load();
            const playPromise = video.play();
            if (playPromise?.catch) playPromise.catch(() => {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.08, rootMargin: '200px 0px' });

      observer.observe(video);
    });
  };

  const init = (scope = document) => {
    splitProduct(scope);
    optimizeVideos(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
